import { QuoteSheetLineItemDTO } from '@/api/procurement/quote-sheets-types';
import { useUpdateQuoteSheetLineItems } from '@/api/procurement/useUpdateQuoteSheetLineItem';
import AssociateProductV2 from '@/components/products/AssociateProductV2';
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { CheckCircleIcon, WarningIcon } from '@phosphor-icons/react';

import { useState } from 'react';
import {
  getEffectiveProductId,
  getEffectiveProductVariantId,
  hasAnySelection,
} from '../utils';
import { Button } from '@/components/ui/button';

const lineItemsTableIconSizeCn = 'h-4 w-4';

export function QuoteSheetAssociateProduct({
  lineItem,
}: {
  lineItem: QuoteSheetLineItemDTO;
}) {
  const [open, setOpen] = useState(false);
  const { mutate: updateLineItems } = useUpdateQuoteSheetLineItems({
    quoteSheetId: lineItem.quoteSheetId,
  });

  return (
    <Popover modal open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon">
          {hasAnySelection(lineItem) ? (
            <CheckCircleIcon
              className={cn(lineItemsTableIconSizeCn, 'text-green-500')}
            />
          ) : (
            <WarningIcon
              className={cn(lineItemsTableIconSizeCn, 'text-yellow-500')}
            />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent side="right" className="w-2xl overflow-y-auto">
        <PopoverArrow />
        <AssociateProductV2
          allowProductSelection={true}
          selectedProductId={getEffectiveProductId(lineItem) ?? undefined}
          selectedProductVariantId={
            getEffectiveProductVariantId(lineItem) ?? undefined
          }
          onProductSelected={(productId) => {
            updateLineItems({
              lineItems: [
                {
                  ...lineItem,
                  selectedProductId: productId,
                },
              ],
            });
            setOpen(false);
          }}
          onVariantSelected={({ productId, productVariantId }) => {
            // Use selected fields when user makes a selection
            updateLineItems({
              lineItems: [
                {
                  ...lineItem,
                  selectedProductId: productId,
                  selectedProductVariantId: productVariantId,
                  // Note: selectedProductVariantId is handled via SupplierProduct creation
                  // For now, we'll clear the suggested fields and set selected product
                },
              ],
            });
            setOpen(false);
          }}
        >
          <span className="pl-2 text-sm font-mono">
            {[lineItem.rawData?.productName, lineItem.locationRaw]
              .filter(
                (property) =>
                  property !== null &&
                  property !== undefined &&
                  property !== '',
              )
              .join(' | ')}
          </span>
        </AssociateProductV2>
      </PopoverContent>
    </Popover>
  );
}
